export const LOCATION_OVERRIDE_COOKIE = "location-override";
export const USER_LOCATION_COOKIE = "prod-edx-cf-loc";
export const USER_REGION_COOKIE = "prod-edx-cf-region";
export const USER_MOBILE_COOKIE = "prod-edx-cf-mobile";
export const WPE_USER_LOCATION_HEADER = "wpe-headless-country";
export const CLOUDFRONT_USER_LOCATION_HEADER = "CloudFront-Viewer-Country";
export const CLOUDFRONT_USER_REGION_HEADER =
  "CloudFront-Viewer-Country-Region-Name";
export const CLOUDFRONT_IS_MOBILE_HEADER = "CloudFront-Is-Mobile-Viewer";
export const USER_LOCATION_LATITUDE = "stage-edx-cf-iplatitude";
export const USER_LOCATION_LONGITUDE = "stage-edx-cf-iplongitude";
export const LOCATION_USA = "US";
export const METERS_IN_ONE_MILE = 1609;
export const PRECISION_RADIUS_MILES = 50;
